import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import '@styles/global.css';
import '@styles/ui.css';
import './stage/stage.css';
import './app.css';
import { ApiError } from './core/http';
import { DataRoot } from './core/provider';
import { installGlobalHandlers } from './core/telemetry';
import { router } from './router';
import { Loading } from './shell/Fatal';

installGlobalHandlers();

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      // Never retry 4xx (auth, permission, not found); retry transient 5xx/network twice.
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <DataRoot fallback={<Loading />}>
        <RouterProvider router={router} />
      </DataRoot>
    </QueryClientProvider>
  </StrictMode>,
);
